import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { QuestionBodyModel } from 'src/app/Models/QuestionBodyByID';
import { AddQuestionByIDModel } from 'src/app/Models/AddQuestionByID';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddQuestionBody } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { RenderMathjax } from '../../../../assets/js/fullscreen';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import { ThisReceiver } from '@angular/compiler';
import Quill from 'quill';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// declare function removetag():any;

@Component({
  selector: 'app-fa-question-body-add-edit',
  templateUrl: './question-body-add-edit.component.html',
  styleUrls: ['./question-body-add-edit.component.css'],
})
export class QuestionBodyAddEditComponent implements OnInit {
  @Input() subjectById: any;
  @Input() selectedQuestionList: any;
  @Input() selectedQuestionById: any;
  @Input() EditQuestionBodyPopup: any;
  @Input() QuestionBodyPopup: any;
  //@Input()
  Buttonflg: string;
  latexeditlist: any[] = [];
  AddQuestionBodyform: FormGroup;
  @Output() EditQuestionBodyclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() AddQuestionBodyclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() Answerchoicepopup: EventEmitter<any> = new EventEmitter<any>();
  @Output() REdirecttoRightAnswer: EventEmitter<any> = new EventEmitter<any>();
  @Output() AddREdirecttoRightAnswer: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() REdirectPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() Questionrefreshpreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() Returnpreview: EventEmitter<any> = new EventEmitter<any>();

  //InsertQuestionBody:QuestionBodyModel;
  TempQuestionBody: AddQuestionByIDModel;
  InsertQuestionBody: AddQuestionByIDModel;
  RTEFlag: string = 'QuestionBody';
  QuestionBodyList: any;
  Question: any;
  QuestionBodyget: string;
  constructor(
    public dom: DomSanitizer,
    public service: QuestionManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}
  InitializeForm() {
    this.AddQuestionBodyform = this.fb.group({
      Question_Text: ['', VAddQuestionBody],
      // Answer_Type_Code:["",VAddQuestion],
      // Answer_Type_Name:["",VAddQuestion],
      // Recommended_Response_Time_Type_Code:["",VAddQuestion],
      // Recommended_Difficulty_Level_Type_Code:["",VAddQuestion],
      // Question_Status_Type_Code:["",VAddQuestion],
      // Question_Gk_Type_Code:["",VAddQuestion],
      // Question_Scope_Type_Code:["",VAddQuestion],
      // RelevantRegion:[],
      // Comment_Text:[],
      // Question_ID:[]
    });
  }

  ngOnInit() {
    this.InitializeForm();
    if (
      this.selectedQuestionById[0].Question_Text != null &&
      this.selectedQuestionById[0].Question_Text != '' &&
      this.selectedQuestionById[0].Question_Text != 'undefined'
    ) {
      this.AddQuestionBodyform.controls['Question_Text'].setValue(
        this.selectedQuestionById[0].Question_Text
      );
      this.QuestionBodyget = this.selectedQuestionById[0].Question_Text;
      this.Descriptioncount();
    } else {
      this.AddQuestionBodyform.controls['Question_Text'].setValue(
        this.selectedQuestionById[0].Question_Text
      );
      this.QuestionBodyget = this.selectedQuestionById[0].Question_Text;
      this.Descriptioncount();
    }

    // removetag();
  }
  QuestionBodyContent: string;

  questionbodycontent: any;
  GetQuestionBodyContent(data: string) {
    this.QuestionBodyContent = data;
    //if(this.QuestionBodyContent!=null)

    this.questionbodycontent = data;

    this.AddQuestionBodyform.controls['Question_Text'].setValue(
      this.QuestionBodyContent
    );
    this.safehtmlStr = this.dom.bypassSecurityTrustHtml(
      this.questionbodycontent
    );
  }

  getQuestionByIDlist: any;
  Questionlist: any;
  Questionid: string;
  Questionstatustypecode: any;
  safehtmlStr: SafeHtml;
  savedsafehtmlStr: SafeHtml;
  getQuestionByID(data: any) {
    this.service.GetQuestionByID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.Questionlist = i;
        this.selectedQuestionById = this.Questionlist.result;
        this.service.QuestionByIDlist = this.selectedQuestionById;
        if (this.selectedQuestionById.length > 0) {
          if (this.selectedQuestionById[0].Question_ID != null) {
            this.AddQuestionBodyform.controls['Question_Text'].setValue(
              this.selectedQuestionById[0].Question_Text
            );
            this.QuestionBodyget = this.selectedQuestionById[0].Question_Text;
            this.savedsafehtmlStr = this.dom.bypassSecurityTrustHtml(
              this.selectedQuestionById[0].Question_Text
            );
            this.Refreshpreview(this.savedsafehtmlStr);
            if (this.alertpopupflag) {
              this.close();
            }

            //this.GetAnswerChoiceByQuestionID(this.getQuestionByIDlist[0].Question_ID);
            // }).catch((e:any)=>{
            //   this.getQuestionByIDlist=null;
            // });
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save_submitted: boolean = false;
  AddQuestionBodyResponse: any;
  index: Number;
  validate1: boolean;
  modalclose: any;
  async SaveQuestionBody() {
    this.validate1 = false;
    if (this.AddQuestionBodyform.valid) {
      // let quillcurrent=extractContent(this.QuestionBodyContent);
      const noSpecialChars = this.QuestionBodyContent.replace(
        /[^a-zA-Z0-9 ]/g,
        ' '
      );
      // const nounderscore = noSpecialChars.replace(/[_]/g, ' ');
      const out = noSpecialChars.replace(/\s/g, '_');
      const out1 = out.replace(/_+/g, '_');
      const name = out1.substr(0, out1.lastIndexOf('_'));
      const first100 = name.slice(0, 100);
      let list: any = {
        Subject_Id: this.service.SelectSubject,
        From_Date: null,
        To_Date: null,
        Question_Status_Type_Code:
          this.selectedQuestionById[0].Question_Status_Type_Code,
        InitialLoadInd: 'N',
        QuestionKeyword1: first100,
        Operator: null,
        QuestionKeyword2: null,
        OwnQuestionInd: null,
      };
      let data = await this.service.getActivityHistorySync(list);
      if (
        data.Data.length == 0 ||
        this.selectedQuestionById[0].Question_Text != '' ||
        this.selectedQuestionById[0].Question_Text != null
      ) {
        this.InsertQuestionBody = this.AddQuestionBodyform.value;
        this.InsertQuestionBody.Allow_Translation_Ind =
          this.selectedQuestionById[0].Allow_Translation_Ind;
        this.InsertQuestionBody.Answer_Selection_Type_Code =
          this.selectedQuestionById[0].Answer_Selection_Type_Code;
        this.InsertQuestionBody.Answer_Type_Code =
          this.selectedQuestionById[0].Answer_Type_Code;
        this.InsertQuestionBody.Comment_Text =
          this.selectedQuestionById[0].Comment_Text;
        this.InsertQuestionBody.Language_Type_Code =
          this.selectedQuestionById[0].Language_Type_Code;
        this.InsertQuestionBody.LanguageInd = this.subjectById.Language_Ind;
        this.InsertQuestionBody.Location_ID =
          this.selectedQuestionById[0].Location_ID;
        this.InsertQuestionBody.Multi_Part_Question_Ind =
          this.selectedQuestionById[0].Multi_Part_Question_Ind;
        this.InsertQuestionBody.Question_Gk_Type_Code =
          this.selectedQuestionById[0].Question_Gk_Type_Code;
        this.InsertQuestionBody.Question_ID =
          this.selectedQuestionById[0].Question_ID;
        this.InsertQuestionBody.Question_Status_Type_Code =
          this.selectedQuestionById[0].Question_Status_Type_Code;
        this.InsertQuestionBody.Question_Template_ID =
          this.selectedQuestionById[0].Question_Template_ID;
        this.InsertQuestionBody.Recommended_Response_Time_Type_Code =
          this.selectedQuestionById[0].Recommended_Response_Time_Type_Code;
        this.InsertQuestionBody.SubjectId = this.subjectById.Subject_Id;
        this.InsertQuestionBody.SubjectShortCode =
          this.subjectById.Subject_Short_Code;
        this.InsertQuestionBody.TranslatingFromQuestionID =
          this.selectedQuestionById[0].TranslatingFromQuestionID;
        this.InsertQuestionBody.Question_Search_Text = first100;
        this.InsertQuestionBody.QuestionPrimaryUsageTypeCode =
          this.selectedQuestionById[0].Question_Primary_Usage_Type_Code ||
          this.selectedQuestionById[0].QuestionPrimaryUsageTypeCode;

        this.service.CreateOrModifyQuestion(this.InsertQuestionBody).subscribe(
          (i: any) => {
            this.AddQuestionBodyResponse = i;
            if (this.AddQuestionBodyResponse.Message == 'Success') {
                          this.toastr.success('Saved Successfully', 'Success', {
              timeOut: 500,
            });
              this.save_submitted = false;
              console.log(this.EditQuestionBodyPopup, 'EditQuestionBodyPopup');
              this.getQuestionByID(this.selectedQuestionById[0].Question_ID);


            } else {
              this.toastr.error(this.AddQuestionBodyResponse.statusText);
            }
          },
          (error) => {
            console.log(error);
            this.AddQuestionBodyResponse = error;
            this.toastr.error(this.AddQuestionBodyResponse.statusText);
            this.save_submitted = false;
          }
        );
      } else {
        this.toastr.warning('Question Already Exist!');
      }
    }
  }

  GetLatexBodyContentchanges(data: boolean) {
    this.validate1 = data;
  }

  Cancel() {
    this.Buttonflg = 'Cancel';

    if (!this.validate1) {
      // if(this.QuestionBodyPopup){

      //   this.AddQuestionBodyclose.emit(this.modalclose);
      // }
      // else{
      //   this.EditQuestionBodyclose.emit(this.modalclose);
      // }
      if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
        this.Buttonflg = 'Cancel';
      }
      if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
        this.Buttonflg = 'RedirecttoAnswer';
      }
      if (this.service.ScreenTrackName == 'app-fa-question-preview') {
        this.Buttonflg = 'Redirecttopreview';
      }

      this.Refreshpreview(
        this.dom.bypassSecurityTrustHtml(this.QuestionBodyget)
      );
      if (this.Buttonflg == 'RedirecttoAnswer') {
        if (this.QuestionBodyPopup) {
          this.AddREdirecttoRightAnswer.emit('R');
        } else {
          this.REdirecttoRightAnswer.emit('R');
        }
      }
      if (this.Buttonflg == 'Cancel') {
        if (this.QuestionBodyPopup) {
          this.AddQuestionBodyclose.emit(this.modalclose);
        } else {
          this.EditQuestionBodyclose.emit(this.modalclose);
        }
      }
      if (this.Buttonflg == 'Redirecttopreview') {
        // if(this.QuestionBodyPopup){
        this.Returnpreview.emit(this.modalclose);
        //}
      }
    } else {
      this.Alertpopup();
    }
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddQuestionBodyform.controls.Question_Text.value != '' &&
      this.AddQuestionBodyform.controls.Question_Text.value != null
    ) {
      if (this.AddQuestionBodyform.controls.Question_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddQuestionBodyform.controls.Question_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  RedirecttoAnswer() {
    this.service.ScreenTrackName = 'app-fa-question-body-add-edit';
    this.Buttonflg = 'RedirecttoAnswer';
    // if(this.QuestionBodyget==this.QuestionBodyContent){
    if (!this.validate1) {
      if (this.QuestionBodyPopup) {
        this.AddREdirecttoRightAnswer.emit('R');
      } else {
        this.REdirecttoRightAnswer.emit('QuestionBody');
      }
    } else {
      this.Alertpopup();
    }
  }

  validate: boolean = false;
  GetLatexBodyContent(data: any) {
    // this.latexeditlist.push({latextext:data.latex,equation:data.mathjax,cursor:data.cursor});
    // console.log(this.latexeditlist,'latexeditlist')
    this.latexeditlist = data;
    // const node = super.create(this.latexeditlist.latex);
    // if (typeof value === 'string') {
    //     node.innerHTML = "&#65279;" + this.tex2svg(value) + "&#65279;";
    //     node.contentEditable = 'false';
    //     node.setAttribute('data-value', value);
    // }

    console.log(this.latexeditlist, 'latexeditlist');
  }

  Indicator: boolean = false;
  RemoveLatexBodyContent(data: any) {
    console.log(data, 'removecursor');
    for (var j = 0; j < this.latexeditlist.length; j++) {
      console.log(data, j, this.latexeditlist[j].cursor);
      if (this.latexeditlist[j].cursor == data) {
        //this.Indicator=true;
        this.latexeditlist.splice(j, 1);
        break;
        //this.Indicator=true;
        //break;
      }
      // if(this.Indicator)
      // {
      // this.latexeditlist[j].cursor=this.latexeditlist[j].cursor-1;
      // }
    }
  }

  Editlatex(data: any, index: any) {
    console.log(data, 'Editlatex');
    let rendermathjax = RenderMathjax(data);
    console.log(rendermathjax, 'mathjax');
    this.latexeditlist[index].latex = data;
    this.latexeditlist[index].mathjax = rendermathjax;
  }

  copyInput(index: any) {
    this.copyMessage(this.latexeditlist[index].latex);
  }

  copyMessage(val: string) {
    document.body.oncopy = function () {
      return true;
    };
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    //document.body.oncopy = function() { return false; }
  }

  alertpopupflag: boolean;
  Alertpopup() {
    this.alertpopupflag = !this.alertpopupflag;
  }

  Savecontent() {
    // if(this.alertpopupflag){
    //   this.Alertpopup();
    // }
    this.validate1 = false;
    this.SaveQuestionBody();
  }

  close() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
      this.Buttonflg = 'Cancel';
    }
    if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
      this.Buttonflg = 'RedirecttoAnswer';
    }
    if (this.service.ScreenTrackName == 'app-fa-question-preview') {
      this.Buttonflg = 'Redirecttopreview';
    }

    this.validate1 = false;
    this.Refreshpreview(this.dom.bypassSecurityTrustHtml(this.QuestionBodyget));
    if (this.Buttonflg == 'RedirecttoAnswer') {
      if (this.QuestionBodyPopup) {
        this.AddREdirecttoRightAnswer.emit('R');
      } else {
        this.REdirecttoRightAnswer.emit('R');
      }
    }
    if (this.Buttonflg == 'Cancel') {
      if (this.QuestionBodyPopup) {
        this.AddQuestionBodyclose.emit(this.modalclose);
      } else {
        this.EditQuestionBodyclose.emit(this.modalclose);
      }
    }
    if (this.Buttonflg == 'Redirecttopreview') {
      //if(this.QuestionBodyPopup){
      this.Returnpreview.emit(this.modalclose);
      //}
    }
  }

  ///Edit latex

  editlatexbutton: boolean;
  getlatex: string;
  currentindex: number;
  Editlatexbutton(index: any) {
    this.currentindex = index;
    this.Editlatexpopup();
    this.getlatex = this.latexeditlist[index].latex;
  }
  Editlatexpopup() {
    this.editlatexbutton = !this.editlatexbutton;
  }

  closelatexpopup() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  Savelatex() {
    this.latexeditlist[this.currentindex].latex = this.getlatex;
    this.Editlatex(this.getlatex, this.currentindex);
    this.copyMessage(this.getlatex);
    if (this.editlatexbutton) {
      this.Editlatexpopup();
    }
  }
  LatexpopupCancel() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  latexalert: boolean;
  latexAlertpopup() {
    this.latexalert = !this.latexalert;
  }

  Savelatexcontent() {
    this.latexAlertpopup();
    this.Savelatex();
  }
  closelatex() {
    this.latexAlertpopup();
    this.Editlatexpopup();
  }

  //preview

  RedirecttoPreview() {
    this.service.ScreenTrackName = 'app-fa-question-body-add-edit';
    let list = {
      safehtmlStr: this.safehtmlStr,
      Screename: 'QuestionBody',
    };
    this.REdirectPreview.emit(list);
  }
  Refreshpreview(data: SafeHtml) {
    let list = {
      safehtmlStr: data,
      Screename: 'QuestionBody',
    };
    this.Questionrefreshpreview.emit(list);
  }

  testformat: any;
  ExtractQuestion() {
    //let quillcurrent=extractContent(this.QuestionBodyContent);
    // this.testformat=format.(quillcurrent)

    // const noSpecialChars = quillcurrent.replace(/[^a-zA-Z0-9 ]/g, '');
    //const noSpecialChars = quillcurrent.replace(/[&\/\\#,+()$~%.'":*?<>{},!-_%@^&*~]/g, '');
    const noSpecialChars = this.QuestionBodyContent.replace(
      /[^a-zA-Z0-9 ]/g,
      ' '
    );
    // const nounderscore = noSpecialChars.replace(/[_]/g, ' ');
    const out = noSpecialChars.replace(/\s/g, '_');
    const out1 = out.replace(/_+/g, '_');
    const name = out1.substr(0, out1.lastIndexOf('_'));

    console.log(name, 'quillcurrent');
  }
}
function extractContent(s: string) {
  var span = document.createElement('html');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}
// console.log(extractContent(this.QuestionBodyContent),'testexact');
// console.log(extractContent(this.selectedQuestionById[0].Question_Text),'testexact');
// let htmlString1 = this.QuestionBodyContent;
// let htmlString2 = this.selectedQuestionById[0].Question_Text;
//  let plainText1 = htmlString1.replace(/<[^>]+>/g, '');
//  let plainText2 = htmlString2.replace(/<[^>]+>/g, '');
// let quillcurrent=extractContent(this.QuestionBodyContent);
// let quill=extractContent(this.selectedQuestionById[0].Question_Text);
